import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quality-admin',
  templateUrl: './quality-admin.component.html',
  styleUrls: ['./quality-admin.component.scss']
})
export class QualityAdminComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
